import React from "react";
import styles from "./styles.module.scss";
import { ItemList } from "./components/StackList";
import usePermission from "../../hooks/usePermission";
import { FeatureStatic } from "../../@types/statics/feature.static";
import { IDefault } from "../../@types/default.type";
import { getConfigurations } from "../../utils/checkConfigurations";
type FeatureStaticKeys = keyof typeof FeatureStatic;

export const Configurations: React.FC = () => {
  const permissions = usePermission();

  const items: Array<{
    icon: string;
    name: string;
    path: string;
    featureKey: FeatureStaticKeys;
  }> = getConfigurations();

  const itemsFilteredByPermission = items.filter((item) => {
    const feature = FeatureStatic[item.featureKey] as IDefault;
    return permissions.canView(feature.id);
  });

  return (
    <>
      <div className={styles.title}>
        <h1>Configurações</h1>
      </div>
      <div>
        <ItemList
          items={itemsFilteredByPermission.map((item) => ({
            ...item,
            icon: <img src={item.icon} alt={item.name} />,
          }))}
        />
      </div>
    </>
  );
};
